import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { createEntity as createFreezeEntity } from 'shared/lib/reducers/card-freeze-request.reducer';
import { createEntity as createUnfreezeEntity } from 'shared/lib/reducers/card-unfreeze-request.reducer';
import { getEntities as getCards } from 'shared/lib/reducers/card.reducer';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { translate } from 'i18n/jhipster-language';
import { CreateHeader, Footer } from 'shared/ui/dialog-header';
import { getErrorMessage } from 'shared/lib/validation/validation';
import { FIELD_CONSTRAINTS } from 'shared/lib/validation/field-constraints';
import { classNames } from 'primereact/utils';
import * as cardRequestCreate from 'shared/lib/validation/card-request-create';
import { buildAuthUserDisplayName } from 'shared/lib/auth-user-display';
import { CARD_REQUEST_REASON_OPTIONS } from 'shared/lib/card-request-form.constants';
import { toCardPickerOption, useCardPickerSearch, CARD_PICKER_ACTIVE_STATUS_QUERY, } from 'features/cards/hooks/use-card-picker-search';
const CARD_PICKER_BASE_FOR_FREEZE = CARD_PICKER_ACTIVE_STATUS_QUERY;
const CARD_PICKER_BASE_FOR_UNFREEZE = {
    'status.equals': 'FROZEN',
};
const CardRequestCreateDialog = ({ requestKind, closeDialog, cardId, active = true, updateSuccess, updating, cards, cardsLoading, account, createRequest, loadCards, }) => {
    const [selectedCardOption, setSelectedCardOption] = useState(null);
    const cardPickerBaseQuery = useMemo(() => (requestKind === 'freeze' ? CARD_PICKER_BASE_FOR_FREEZE : CARD_PICKER_BASE_FOR_UNFREEZE), [requestKind]);
    const { onFilter: onCardFilter } = useCardPickerSearch(active, loadCards, cardPickerBaseQuery);
    const cardOptions = useMemo(() => {
        const opts = cards
            .map(toCardPickerOption)
            .filter((o) => o != null);
        if (selectedCardOption && !opts.some(o => o.id === selectedCardOption.id)) {
            return [selectedCardOption, ...opts];
        }
        return opts;
    }, [cards, selectedCardOption]);
    const formik = cardRequestCreate.form({
        kind: requestKind,
        createEntity: createRequest,
    });
    const formikRef = useRef(formik);
    formikRef.current = formik;
    useEffect(() => {
        if (cardId) {
            formikRef.current.setFieldValue('cardId', cardId);
            const picked = toCardPickerOption(cards.find(c => c.id === cardId) ?? { id: cardId });
            if (picked) {
                setSelectedCardOption(picked);
            }
        }
    }, [cardId, cards]);
    const performerLabelRef = useRef('');
    useEffect(() => {
        const label = buildAuthUserDisplayName(account ?? {});
        if (label) {
            performerLabelRef.current = label;
            formikRef.current.setFieldValue('performedBy', label);
        }
    }, [account]);
    useEffect(() => {
        if (!updateSuccess) {
            return;
        }
        formikRef.current.resetForm();
        formikRef.current.setFieldValue('sourceChannel', 'BRANCH');
        const label = performerLabelRef.current;
        if (label) {
            formikRef.current.setFieldValue('performedBy', label);
        }
        closeDialog?.();
    }, [updateSuccess, closeDialog]);
    const getFormError = (name) => getErrorMessage(name, formik);
    const fieldClass = (invalid) => classNames('w-full', { 'p-invalid': invalid });
    const entityLabelKey = requestKind === 'freeze' ? 'form.cardFreezeRequest' : 'form.cardUnfreezeRequest';
    const reasonFieldId = requestKind === 'freeze' ? 'freeze-reason' : 'unfreeze-reason';
    const reasonLabel = requestKind === 'freeze' ? translate('form.freezeReason') : translate('form.reasonLabel');
    const cardFieldId = requestKind === 'freeze' ? 'freeze-card-id' : 'unfreeze-card-id';
    return (_jsxs("div", { className: "p-mt-2", style: { maxHeight: '80vh', overflowY: 'auto' }, children: [_jsx(PCol, { children: _jsx(PRow, { justify: "between", className: "p-mb-2 p-mt-3", children: _jsx(PCol, { col: 10, children: _jsx(CreateHeader, { headername: translate('entity.action.create', {
                                entity: translate(entityLabelKey),
                            }) }) }) }) }), _jsx(PCol, { children: _jsxs("form", { onSubmit: formik.handleSubmit, onBlur: formik.handleBlur, children: [_jsxs(PRow, { children: [_jsxs(PCol, { col: 4, className: "p-field", children: [_jsxs("label", { htmlFor: cardFieldId, children: [translate('form.card'), " *"] }), _jsx(Dropdown, { id: cardFieldId, className: fieldClass(!!(formik.touched.cardId && formik.errors.cardId)), options: cardOptions, optionLabel: "label", optionValue: "id", value: formik.values.cardId, onChange: e => {
                                                const nextId = e.value;
                                                formik.setFieldValue('cardId', nextId);
                                                if (nextId == null) {
                                                    setSelectedCardOption(null);
                                                    return;
                                                }
                                                const picked = cardOptions.find(o => o.id === nextId);
                                                if (picked) {
                                                    setSelectedCardOption(picked);
                                                }
                                            }, onBlur: () => formik.setFieldTouched('cardId', true), onFilter: onCardFilter, filter: true, filterBy: "label", showClear: !cardId, disabled: !!cardId, placeholder: cardsLoading ? translate('form.loading') : undefined }), _jsx("small", { className: "p-error", children: getFormError('cardId') })] }), _jsxs(PCol, { col: 4, className: "p-field", children: [_jsxs("label", { htmlFor: reasonFieldId, children: [reasonLabel, " *"] }), _jsx(Dropdown, { id: reasonFieldId, className: fieldClass(!!(formik.touched.reason && formik.errors.reason)), options: CARD_REQUEST_REASON_OPTIONS, optionLabel: "name", optionValue: "value", value: formik.values.reason, onChange: e => formik.setFieldValue('reason', e.value), onBlur: () => formik.setFieldTouched('reason', true) }), _jsx("small", { className: "p-error", children: getFormError('reason') })] }), requestKind === 'unfreeze' ? (_jsxs(PCol, { col: 12, className: "p-field", children: [_jsx("label", { htmlFor: "unfreeze-reason-detail", children: translate('form.unfreezeReason') }), _jsx(InputTextarea, { id: "unfreeze-reason-detail", className: fieldClass(!!(formik.touched.unfreezeReason && formik.errors.unfreezeReason)), rows: 3, value: formik.values.unfreezeReason, onChange: e => formik.setFieldValue('unfreezeReason', e.target.value), onBlur: () => formik.setFieldTouched('unfreezeReason', true), maxLength: FIELD_CONSTRAINTS.DESCRIPTION_MAX }), _jsx("small", { className: "p-error", children: getFormError('unfreezeReason') })] })) : null, requestKind === 'freeze' ? (_jsx(_Fragment, { children: _jsxs(PCol, { col: 12, className: "p-field", children: [_jsx("label", { htmlFor: "freeze-notes", children: translate('form.note') }), _jsx(InputTextarea, { id: "freeze-notes", className: fieldClass(!!(formik.touched.notes && formik.errors.notes)), rows: 3, value: formik.values.notes, onChange: e => formik.setFieldValue('notes', e.target.value), onBlur: () => formik.setFieldTouched('notes', true), maxLength: FIELD_CONSTRAINTS.DESCRIPTION_MAX }), _jsx("small", { className: "p-error", children: getFormError('notes') })] }) })) : null] }), _jsx(Footer, { closeDialog: closeDialog, className: "p-py-1", updating: updating })] }) })] }));
};
const mapStateToProps = (state, ownProps) => {
    const slice = ownProps.requestKind === 'freeze' ? state.cardFreezeRequest : state.cardUnfreezeRequest;
    return {
        updateSuccess: slice.updateSuccess,
        updating: slice.updating,
        cards: state.card.entities,
        cardsLoading: state.card.loading,
        account: state.cmsAccount.account,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
    loadCards: (params) => dispatch(getCards(params)),
    createRequest: (body) => {
        if (ownProps.requestKind === 'freeze') {
            return dispatch(createFreezeEntity(body));
        }
        return dispatch(createUnfreezeEntity(body));
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(CardRequestCreateDialog);
